import { Component, Prop, State, h, Host, Fragment } from '@stencil/core';
import { Product } from '../../types/product.type';
import { money } from '../../utils/utils';

@Component({
  tag: 'qumra-product-card',
  styleUrl: 'qumra-product-card.css',
  shadow: false, // يُفضل استخدام shadow DOM لعزل CSS
})

export class QumraProductCard {
  // خصائص المنتج
  @Prop() product: string;
  @Prop() mainColor: string;
  @Prop() whatsapp: boolean | string = false
  @Prop() phone: boolean | string = true
  @Prop() buttonText: string = 'اضافة للسلة';
  @Prop() skeletonLoading: boolean = false;

  @State() loading: boolean = false;
  @State() priceAtCallLoading: boolean = false;
  @State() productObj: Product;
  @State() type: string = 'none';
  @State() localType: string = 'none';

  constructor() {
   
    try {
      this.productObj = this.product ? JSON.parse(this.product) : {};
  } catch (error) {
      console.error('🚨 خطأ في JSON.parse:', error);
      this.productObj = {};
  }
    this.whatsapp = this.whatsapp === "true" || this.whatsapp === true;
    this.phone = this.phone === "true" || this.phone === true;

    const { mainColor } = window.__qumra__.data.app.settings;
    this.mainColor = mainColor;

    this.addToCart.bind(this);
    this.priceAtCallMethod.bind(this);
  }
  async addToCart() {
    this.loading = true;
    window.Qumra.cart.addCartItem(this.productObj?._id, 1).finally(() => {
      this.loading = false;
    });
  }

  async priceAtCallMethod(type: string) {
    this.localType = type;
    this.priceAtCallLoading = true;

    window.Qumra.product.productPriceAtCall(type)
      .then((res) => {
        if (res.type === 'whatsapp') {
          window.location.href = `https://wa.me/${res?.phone}`;
        } else {
          window.location.href = `tel:${res?.phone}`;
        }
        this.localType = res.type;
      })
      .catch(() => {
        this.localType = 'none';
      })
      .finally(() => {
        this.priceAtCallLoading = false;
      });
  }




  createStarRating(rating: number) {
    const stars = [];
  
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
  
    // نجمة مليانة
    const fullStarSVG = (
      <svg width="10" height="11" viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg" fill="#FFC107">
        <g clip-path="url(#clip0_505_6660)">
          <path d="M5.24249 0.459689L6.52097 3.59376L9.7656 3.89778C9.81684 3.90218 9.86568 3.9224 9.90599 3.95588C9.94629 3.98937 9.97625 4.03462 9.99209 4.08594C10.0079 4.13726 10.0089 4.19235 9.99499 4.24427C9.98104 4.2962 9.95276 4.34262 9.91371 4.37771L7.45766 6.62365L8.18194 9.95414C8.18951 9.98913 8.19041 10.0253 8.1846 10.0607C8.17878 10.0961 8.16637 10.1299 8.14807 10.1602C8.12977 10.1905 8.10594 10.2167 8.07796 10.2373C8.04998 10.258 8.01838 10.2726 7.985 10.2804C7.91595 10.2956 7.84393 10.2815 7.78481 10.2411L4.99753 8.49556L2.20294 10.2496C2.17374 10.2682 2.14133 10.2805 2.10757 10.2859C2.07382 10.2913 2.03938 10.2896 2.00625 10.2809C1.97311 10.2723 1.94194 10.2568 1.91452 10.2355C1.8871 10.2141 1.86398 10.1873 1.84649 10.1565C1.82897 10.1264 1.81729 10.0929 1.81213 10.0581C1.80696 10.0232 1.8084 9.98757 1.81638 9.95328L2.54148 6.6228L0.0886777 4.37771C0.0371213 4.32971 0.00552624 4.26243 0.000658811 4.19028C-0.00420861 4.11814 0.0180386 4.04686 0.062636 3.99171C0.111788 3.93887 0.178649 3.90823 0.248997 3.90632L3.48142 3.6023L4.7599 0.459689C4.78052 0.410571 4.81432 0.368808 4.85716 0.339487C4.9 0.310167 4.95005 0.294556 5.0012 0.294556C5.05234 0.294556 5.10239 0.310167 5.14523 0.339487C5.18807 0.368808 5.22187 0.410571 5.24249 0.459689Z"/>
        </g>
        <defs>
          <clipPath id="clip0_505_6660">
            <rect width="10" height="10" fill="white" transform="translate(0 0.28894)" />
          </clipPath>
        </defs>
      </svg>
    );
  
    // نجمة فاضية
    const emptyStarSVG = (
      <svg width="10" height="11" viewBox="0 0 10 11" xmlns="http://www.w3.org/2000/svg" fill="none">
        <g clip-path="url(#clip0_505_6658)">
          <path d="M1.84649 10.1565C1.86398 10.1873 1.8871 10.2141 1.91452 10.2355C1.94194 10.2568 1.97311 10.2723 2.00625 10.2809C2.03938 10.2896 2.07382 10.2913 2.10757 10.2859C2.14133 10.2805 2.17374 10.2682 2.20294 10.2496L1.84649 10.1565ZM6.05801 3.78262L6.17251 4.0633L6.47433 4.09158L9.20581 4.34752L7.12024 6.25467L6.90795 6.4488L6.96908 6.7299L7.57591 9.5203L5.26291 8.07179L4.99723 7.90541L4.73172 8.07206L2.42204 9.52176L3.03003 6.72916L3.09121 6.44815L2.87907 6.25397L0.805682 4.35617L3.52824 4.10011L3.83025 4.0717L3.94456 3.79072L5.0015 1.19269L6.05801 3.78262Z" stroke="#ADADAD"/>
        </g>
        <defs>
          <clipPath id="clip0_505_6658">
            <rect width="10" height="10" fill="white" transform="translate(0 0.28894)" />
          </clipPath>
        </defs>
      </svg>
    );
  
    // مفيش SVG جاهز للنص نجمة، هنستخدم نجمة كاملة مؤقتًا (أو تقدر ترفع SVG لنصف نجمة وتستبدله هنا)
    const halfStarSVG = fullStarSVG;
  
    for (let i = 0; i < fullStars; i++) {
      stars.push(fullStarSVG);
    }
  
    if (hasHalfStar) {
      stars.push(halfStarSVG);
    }
  
    for (let i = 0; i < emptyStars; i++) {
      stars.push(emptyStarSVG);
    }
  
    return stars;
  }
  
  render() {

    return (
      <Host class={"w-full"}>
        <qumra-skeleton loading={this.skeletonLoading}>
          <div class=" product-card group  relative">
            <div class="h-full" >
              <a aria-label="toProductPage" href={`/product/${this.productObj?.slug}`} class="image-container block h-full">
                {this.productObj?.images.length > 0 ?

                  <img loading="lazy" class="product-image group-hover:scale-105 cursor-pointer"
                    src={this.productObj?.images[0]?.imageUrl} alt={this.productObj?.title} />

                  : <qumra-skeleton>
                    <div class=" empty-image">لا يوجود صورة</div>
                  </qumra-skeleton>
                }
              </a>
            </div>
            {this.productObj?.discount > 0 && <span class="discount ">
              {this.productObj?.discountType === 'percentage' ? this.productObj?.discount + '%' : "-" + money(this.productObj?.discount)}
            </span>}
            <div class=" card-body">

              <a aria-label="toProductDetails" href={`/product/${this.productObj?.slug}`} class="cart-details">
                <div class=" grid">
                  <h3 class="product-title  w-full truncate">{this.productObj?.title}</h3>
                </div>
                <div class=" rate-container ">
                  <div style={{ display: this.productObj?.rate > 0 ? 'flex' : 'none' }} class="star-container">
                    {this.productObj?.rate > 0 ? this.createStarRating(this.productObj?.rate) : null}
                  </div>
                  <p class="rate">{this.productObj?.rate === 0 ? 'لا يوجد تقييمات' : this.productObj?.rate?.toFixed(2)}</p>
                </div>
                {!this.productObj?.privatePrice && 
                <div>
                  
                  {this.productObj?.discount == 0 ? (<div class="flex justify-start"><span class="text-price-without-discount">{money(this.productObj?.price)}</span></div>) :
                    (
                      <div >
                        <div class="price-container">
                          <span class="price-discount">{money(this.productObj?.priceAfterDiscount)}</span>
                          <span class="price">
                            {money(this.productObj?.price)}
                          </span>
                        </div>
                      </div>
                    )
                  }
                </div>}
              </a>

              <div class=" card-footer">

                {this.productObj?.privatePrice ? (
                  <div class="private-price-container">
                    <div class="private-price-title">السعر عند الاتصال:</div>
                    <div class="social-container">
                      {this?.phone && (
                        <button
                          aria-label="الاتصال"
                          onClick={() => this.priceAtCallMethod('call')}
                          class={`cart-button-social-phone`}
                          disabled={this.priceAtCallLoading && this.localType === 'whatsapp'}
                        >
                          {!this.priceAtCallLoading || this.localType !== 'call' ? (
                            <Fragment>
                              <i class="fi flex items-center fi-rr-phone-call text-white"></i>
                              الاتصال
                            </Fragment>
                          ) : (
                            <qumra-loading borderType='dashed' loading-size="20px" loading={true}></qumra-loading>
                          )}
                        </button>
                      )}

                      {this?.whatsapp && (
                        <button
                          aria-label="التواصل واتساب"
                          onClick={() => this.priceAtCallMethod('whatsapp')}
                          class={`cart-button-social-whatsapp`}
                          disabled={this.priceAtCallLoading && this.localType === 'call'}
                        >
                          {!this.priceAtCallLoading || this.localType !== 'whatsapp' ? (
                            <Fragment>
                              <svg width="16" height="16" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M0 20.2001L1.43495 14.8694C0.2777 12.7928 -0.0899718 10.3695 0.399408 8.04437C0.888789 5.7192 2.20239 3.64804 4.09918 2.21095C5.99596 0.773868 8.34868 0.0672552 10.7256 0.220779C13.1026 0.374303 15.3443 1.37767 17.0394 3.04675C18.7345 4.71583 19.7694 6.93867 19.9541 9.30738C20.1387 11.6761 19.4608 14.0318 18.0447 15.9422C16.6286 17.8526 14.5694 19.1895 12.2448 19.7077C9.92021 20.2259 7.48625 19.8905 5.38955 18.7632L0 20.2001ZM5.64943 16.7684L5.98274 16.9656C7.50142 17.8635 9.27522 18.235 11.0277 18.0224C12.7802 17.8097 14.4129 17.0248 15.6715 15.7899C16.9301 14.555 17.7437 12.9395 17.9857 11.1952C18.2277 9.45093 17.8844 7.67578 17.0093 6.14641C16.1342 4.61703 14.7765 3.41935 13.1478 2.74C11.519 2.06065 9.71075 1.9378 8.0047 2.39058C6.29864 2.84336 4.79067 3.84635 3.71576 5.24324C2.64086 6.64014 2.05942 8.35246 2.06204 10.1134C2.06061 11.5735 2.46544 13.0053 3.23147 14.2495L3.4405 14.5933L2.63828 17.5686L5.64943 16.7684Z"
                                  fill={"white"}
                                />
                              </svg>
                              واتساب
                            </Fragment>
                          ) : (
                            <qumra-loading borderType='dashed' loading-size="20px" loading={true}></qumra-loading>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                ) : 
                this.productObj?.privatePrice == undefined ? (
                (
                 <button
                    class="cart-button"
                    onClick={this.addToCart.bind(this)}
                    disabled={this.loading}
                  >
                    {!this.loading ? "السعر عند الاتصال" : <qumra-loading borderType="dashed" loading-size="20px" loading={true}></qumra-loading>}
                  </button>
                )
                ) : (
                  <button
                  class="cart-button"
                  onClick={this.addToCart.bind(this)}
                  disabled={this.loading}
                >
                  {!this.loading ? "أضف إلى السلة" : <qumra-loading borderType="dashed" loading-size="20px" loading={true}></qumra-loading>}
                </button>
                )
              
              }


              </div>

            </div>
          </div>
        </qumra-skeleton>
      </Host>

    );

  }
}
